import { render, staticRenderFns } from "./password-updated.vue?vue&type=template&id=7ebec9aa&"
import script from "./password-updated.vue?vue&type=script&lang=js&"
export * from "./password-updated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports